/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {
  ViewComponentKey
} from '@typescript-kit/view';
import {
  ComponentProvider,
} from '@angular-kit/view';
import {
  BsButtonComponent,
  BsTextInputComponent,
  BsSelectInputComponent,
  BsDropdownComponent,
  BsTableComponent,
  BsFormFieldComponent,
  BsAlertComponent
} from '@angular-kit/bs-view';

export class AppInitializer {

  static initialize() {
    AppInitializer.registerComponents();
  }

  static registerComponents() {
    ComponentProvider.registerComponentType(ViewComponentKey.ACTION, BsButtonComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.BUTTON, BsButtonComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.DROPDOWN, BsDropdownComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TABLE, BsTableComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.TEXT_INPUT, BsTextInputComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.SELECT_INPUT, BsSelectInputComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.FORM_FIELD, BsFormFieldComponent);
    ComponentProvider.registerComponentType(ViewComponentKey.ALERT, BsAlertComponent);
  }

}
